import React from "react"
import ReactDOM from "react-dom"
import ArticleTextUsp from "./article-text-usp-component"

export default class ArticleTextUspModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ArticleTextUsp {...self.modelJson} />, self.elem)
  }
}
